import { render, staticRenderFns } from "./Create-Template.vue?vue&type=template&id=572ccd8b&"
import script from "./Create-Template.vue?vue&type=script&lang=js&"
export * from "./Create-Template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports